function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IalertCircleWhite = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    notChangeable: true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM5.76698 16.2774H18.2336C18.5514 16.2774 18.747 15.9352 18.5759 15.6419L12.3425 5.61964C12.1959 5.35075 11.8292 5.35075 11.6581 5.61964L5.42475 15.6419C5.25364 15.9352 5.4492 16.2774 5.76698 16.2774ZM11.9999 8.82422C11.6088 8.82422 11.291 9.142 11.291 9.53311V11.562C11.291 11.9531 11.6088 12.2709 11.9999 12.2709C12.391 12.2709 12.7088 11.9531 12.7088 11.562V9.53311C12.7088 9.142 12.391 8.82422 11.9999 8.82422ZM11.9999 12.9793C11.6088 12.9793 11.291 13.2971 11.291 13.6882V13.7126C11.291 14.1037 11.6088 14.4215 11.9999 14.4215C12.391 14.4215 12.7088 14.1037 12.7088 13.7126V13.6882C12.7088 13.2971 12.391 12.9793 11.9999 12.9793Z",
    fill: "white"
  }));
});